var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrowRight_svg__mask0_14021_11333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 9
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.358398,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrowRight_svg__mask0_14021_11333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "arrowRight_svg__mask1_14021_11333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.358398,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrowRight_svg__mask1_14021_11333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6001 1.5582L5.4001 4.3582L2.6001 7.1582",
    stroke: "white",
    strokeOpacity: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
export default SvgArrowRight;